var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.942,
    height: 29.882,
    viewBox: "0 0 16.942 29.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15497",
    "data-name": "Group 15497",
    transform: "translate(6493.061 2959) rotate(90)",
    opacity: 0.595
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13789",
    "data-name": "Path 13789",
    d: "M62.857,79.11a9.008,9.008,0,0,0-6.414,2.657A1.721,1.721,0,0,0,58.877,84.2a5.627,5.627,0,0,1,7.959,0,1.721,1.721,0,0,0,2.434-2.434,9.008,9.008,0,0,0-6.414-2.657",
    transform: "translate(-3006.915 6408.356)",
    fill: "#09bc8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13790",
    "data-name": "Path 13790",
    d: "M38.924,39.6A14.641,14.641,0,0,0,28.5,43.916a1.721,1.721,0,0,0,2.434,2.434,11.3,11.3,0,0,1,15.975,0,1.721,1.721,0,1,0,2.434-2.434A14.638,14.638,0,0,0,38.924,39.6",
    transform: "translate(-2982.982 6442.2)",
    fill: "#09bc8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13791",
    "data-name": "Path 13791",
    d: "M29.38,5.981A20.416,20.416,0,0,0,.5,5.981,1.721,1.721,0,1,0,2.938,8.415a16.973,16.973,0,0,1,24.007,0A1.721,1.721,0,0,0,29.38,5.981",
    transform: "translate(-2959 6476.119)",
    fill: "#09bc8a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundWaves);
export default __webpack_public_path__ + "static/media/sound-waves.ac8a960f1c60ce5315890454f2aa0986.svg";
export { ForwardRef as ReactComponent };